/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CommentResponse,
  CreateCommentRequest,
  EstimationCommentResponse,
  EstimationItemCommentResponse,
  V1CommentsCreateError,
  V1EstimationItemsCommentsListError,
  V1EstimationsCommentsListError,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Comment<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Comment
   * @name V1EstimationsCommentsList
   * @request GET:/api/v1/estimations/{estimationId}/comments
   * @secure
   * @response `200` `(EstimationCommentResponse)[]` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsCommentsList = (estimationId: string, params: RequestParams = {}) =>
    this.http.request<EstimationCommentResponse[], V1EstimationsCommentsListError>({
      path: `/api/v1/estimations/${estimationId}/comments`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Comment
   * @name V1EstimationItemsCommentsList
   * @request GET:/api/v1/estimation-items/{estimationItemId}/comments
   * @secure
   * @response `200` `(EstimationItemCommentResponse)[]` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationItemsCommentsList = (estimationItemId: string, params: RequestParams = {}) =>
    this.http.request<EstimationItemCommentResponse[], V1EstimationItemsCommentsListError>({
      path: `/api/v1/estimation-items/${estimationItemId}/comments`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Comment
   * @name V1CommentsCreate
   * @request POST:/api/v1/comments
   * @secure
   * @response `200` `CommentResponse` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `403` `ProblemDetailsWithErrorCode` Forbidden
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1CommentsCreate = (data: CreateCommentRequest, params: RequestParams = {}) =>
    this.http.request<CommentResponse, V1CommentsCreateError>({
      path: `/api/v1/comments`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
